<template>
  <div>
    <div class="configurator box-outline mb-2">
      <div class="box-title">
        <h3>Válaszd ki a futamidőt és a km futást</h3>
      </div>
      <div class="box-content">
        <contract-length-selector :lead="lead" />
        <annual-mileages-selector :lead="lead" />
        <initial-payment-selector />
      </div>
      <div class="box-footer">
        <span>Bérleti díj:</span>
        <h5 v-if="calculatedPrice">
          {{ calculatedPrice | currency }} Ft + ÁFA / hó
        </h5>
        <h5 v-else>
          Hívjon bennünket!
        </h5>
        <hr>
        <div class="text-right">
          <span>Induló bérleti díj:</span>
          <h6 v-if="calculatedPrice">
            {{ initialPayment | currency }} Ft + ÁFA
          </h6>
          <h6 v-else>
            Hívjon bennünket!
          </h6>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-success btn-lg btn-block"
      @click="onSaveLead()"
    >Tovább!
    </button>

  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';
  import ContractLengthSelector from './Configurator/ContractLengthSelector';
  import AnnualMileagesSelector from './Configurator/AnnualMileagesSelector';
  import InitialPaymentSelector from './Configurator/InitialPaymentSelector';

  const configuratorModule = namespace('configurator');

  @Component({
    components: {InitialPaymentSelector, AnnualMileagesSelector, ContractLengthSelector}
  })
  export default class ConfiguratorCalculator extends Vue {
    @configuratorModule.Getter('getInitialPayment') initialPayment;
    @configuratorModule.Getter('getCalculatedPrice') calculatedPrice;
    @configuratorModule.Action('initialize') initialize;
    @configuratorModule.Action('saveLead') saveLead;
    @configuratorModule.Action('loadLead') loadLead;

    @Prop(String) typeId;
    @Prop(Number) m;
    @Prop(Number) k;
    @Prop(Number) prinp2;
    @Prop(Object) prices;
    @Prop(Object) lead;
    @Prop(Boolean) userLogged;
    @Prop(String) currentLeadId;

    saved = false;

    created() {
      this.initialize({
        typeId: this.typeId,
        prices: this.prices,
        prinp2: this.prinp2,
        m: this.m,
        k: this.k,
        currentLeadId: this.currentLeadId
      });

      if (this.lead) {
        this.loadLead(this.lead);
      }

    }

    onSaveLead() {
      this.saveLead(false)
        .then((lead) => {
          window.location.href = `/hu/szemelygepkocsi/megerosites/?lead=${lead.id}`
        });
    }
  }
</script>
